import styled from 'styled-components';
import { crTheme, Button } from '@comicrelief/component-library';
import {
  ReusableStylesHideInputElement, ReusableStylesFocusVisibleOnWrapper,
  StyledFieldset
} from '../../components/global/Global.style';

interface AudienceSelectLabelProps {
  selected: boolean,
  $errorstate: boolean
}

const PayInAudienceContinueButton = styled(Button)`
    margin: 0 !important;
`;

const AudienceSelectRadioButton = styled.input`
  ${ReusableStylesHideInputElement}
`;

const AudienceSelectWrapper = styled(StyledFieldset)`
    width: 100%;
    height: 100%;
    padding: 4px;
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 20px 0px 0px;
`;

const AudienceSelectLabel = styled.label<AudienceSelectLabelProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
    flex-basis: 0;
    padding: 15px 15px;
    line-height: 18px;
    font-weight: bold;
    font-family: Montserrat, Impact, sans-serif;
    background: ${({ selected }) => (selected ? crTheme.color('blue_donate') : crTheme.color('white'))};
    color: ${({ selected }) => (selected ? crTheme.color('white') : crTheme.color('black'))};
    border-radius: 0.5rem;
    transition: background-color linear 0.2s, color linear 0.2s;
    margin-bottom: 20px;
    outline: 1px solid ${({ $errorstate }) => ($errorstate ? crTheme.color('red') : crTheme.color('grey'))};
    gap: 20px;

    &:hover {
        background-color: ${({ selected }) => (selected ? crTheme.color('blue_donate_interact') : crTheme.color('grey_light'))};
    }

    ${ReusableStylesFocusVisibleOnWrapper}
`;

const AudienceImage = styled.img`
    display: block;
    width: 64px;
    height: 64px;
    object-fit: cover;
    object-position: top;
    border-radius: 0.5rem;
`;

export {
  AudienceSelectWrapper, AudienceSelectRadioButton, AudienceSelectLabel, AudienceImage, PayInAudienceContinueButton,
};
